import { setTerms } from '@/packages/JsonQuery/helpers';

export const setEntranceType = setTerms('input_type');
